import { c as _c } from "react/compiler-runtime";
export const PulsingDot = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <span className="w-2 h-2 bg-white/90 rounded-full animate-pulse relative"><span className="absolute inset-0 bg-white/60 rounded-full blur-[0.125rem] animate-pulse" /></span>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};